import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { Form } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import { VENDORLINK_MAPPINGS_FORM_NAME } from 'Common/FormEnum';
import { TitledCard } from 'Components/';
import {
  VendorLinkMapOptions,
  VendorLinkFieldEnum,
  VendorLinkMapConfig,
} from 'Common/Constants/SISIntegration';
import SISFields from 'Common/SISFields';

export class VendorLinkMappingFormContainer extends Component {
  static propTypes = {
    siteOptions: PropTypes.array.isRequired,
    gradeOptions: PropTypes.array.isRequired,
    languageOptions: PropTypes.array.isRequired,
    statusCodeOptions: PropTypes.array.isRequired,
    siteSourceOptions: PropTypes.array,
  };

  render() {
    const {
      siteOptions,
      gradeOptions,
      languageOptions,
      statusCodeOptions,
      siteSourceOptions,
    } = this.props;

    return (
      <Form name={VENDORLINK_MAPPINGS_FORM_NAME}>
        <TitledCard title="Field Mapping">
          <SISFields
            integrationMapOptions={VendorLinkMapOptions}
            integrationMapConfig={VendorLinkMapConfig}
            integrationMapData={{
              [VendorLinkFieldEnum.SiteMapping]: siteOptions,
              [VendorLinkFieldEnum.GradeMapping]: gradeOptions,
              [VendorLinkFieldEnum.LanguageMapping]: languageOptions,
              [VendorLinkFieldEnum.StatusCodeMapping]: statusCodeOptions,
            }}
            integrationSourceOptions={{
              [VendorLinkFieldEnum.SiteMapping]: siteSourceOptions,
            }}
          />
        </TitledCard>
      </Form>
    );
  }
}

const validate = values => {
  const errors = {};

  //for each map field
  VendorLinkMapOptions.forEach(field => {
    if (!values[field.key]) {
      errors[field.key] = 'Please select an option.';
    }
  });

  return errors;
};

export const VendorLinkMappingForm = reduxForm({
  form: VENDORLINK_MAPPINGS_FORM_NAME,
  validate,
})(VendorLinkMappingFormContainer);



// WEBPACK FOOTER //
// ./src/pages/vendorlinkintegration/components/VendorLinkMappingStep/VendorLinkMappingForm.js